/*
 * =============================================================================
 * FRETE NO CARRINHO — módulo compartilhado
 * =============================================================================
 * Cliente reclamava de só descobrir o valor do transporte no checkout, depois de
 * preencher o endereço inteiro (14/08/2026). Aqui ele vê antes de decidir.
 *
 * É CONSULTA, NÃO SELEÇÃO. A Shopify recalcula o frete do zero no checkout a partir
 * do endereço digitado lá; fora do Plus não existe como levar daqui uma
 * transportadora escolhida. O ganho é saber o custo antes de investir tempo
 * preenchendo endereço.
 *
 * NÃO MEXE NO CARRINHO, e é a diferença para o cálculo da página de produto. Lá o
 * script precisa cotar UM item, então salva o carrinho, limpa, adiciona só aquele
 * produto, consulta, limpa de novo e restaura item a item. Aqui o carrinho JÁ É o
 * que queremos cotar: uma chamada, sem risco de perder carrinho de cliente se algo
 * falhar no meio.
 *
 * A UF vem do ViaCEP porque o `shipping_rates.json` exige a província — CEP sozinho
 * ele recusa.
 *
 * -----------------------------------------------------------------------------
 * POR QUE ESTE ARQUIVO EXISTE, EM VEZ DE VIVER DENTRO DO DRAWER
 * -----------------------------------------------------------------------------
 * O código nasceu dentro do `cart-drawer-decimal.js`, achando cada elemento por
 * `getElementById('drawer-frete-…')`. Quando o mesmo cartão foi para a página
 * /cart isso deixou de funcionar, e não por estilo: o drawer é renderizado pelo
 * `theme.liquid` em TODAS as páginas, então no /cart existem os dois cartões no
 * mesmo documento. `getElementById` devolve o primeiro — o da página, porque o
 * drawer vem no fim do body — e o frete do drawer passaria a mexer nos campos da
 * página. Um id só pode existir uma vez; dois cartões precisam de escopo.
 *
 * Então aqui nada se acha por id. Cada cartão é um elemento com `data-cbv-frete`,
 * e tudo dentro dele é procurado por classe, a partir dele. Dois, três, quantos
 * couberem na página, cada um com seu estado.
 *
 * -----------------------------------------------------------------------------
 * O QUE O HTML PRECISA DECLARAR
 * -----------------------------------------------------------------------------
 *   data-cbv-frete           marca o cartão (o escopo). Obrigatório.
 *   data-delivery-rules      JSON das faixas de prazo configuradas no tema.
 *   data-frete-subtotal      seletor CSS de onde escrever a linha de subtotal.
 *   data-frete-prefixo       texto antes do valor ("Subtotal: " no drawer, vazio
 *                            no /cart, onde o rótulo já é um <span> à parte).
 *
 * Classes procuradas dentro do escopo (todas opcionais menos as três primeiras):
 *   .cbv-frete__cep          o input
 *   .cbv-frete__calcular     o botão da cápsula
 *   .cbv-frete__resultado    onde sai o seletor de modalidades
 *   .cbv-frete__corpo        o corpo recolhível — só onde o cartão recolhe
 *   .cbv-frete__abrir        a ação do cabeçalho ("Calcular")
 *   .cbv-frete__etiqueta     a etiqueta do CEP já calculado
 *   .cbv-frete__etiqueta-texto
 *   .cbv-frete__limpar       o "×" da etiqueta
 *
 * No /cart o cartão não recolhe: as quatro últimas simplesmente não existem, e
 * todas as funções aqui toleram a ausência. Não há duas versões do código — há
 * um código que não exige o que nem sempre está lá.
 */
(function () {
  'use strict';

  if (window.cbvFrete) return;

  var CHAVE_CEP = 'cbv:cep';

  /*
   * Subtotal de MERCADORIA em centavos — a base sobre a qual o frete é somado.
   *
   * Quem lê o carrinho avisa (`cbvFrete.definirBase`). O módulo não busca sozinho
   * de propósito: o drawer e o /cart já fazem esse GET por outros motivos, e uma
   * terceira chamada só para saber o que já está escrito na tela seria desperdício
   * numa página que a gente passou dias enxugando.
   */
  var baseCents = null;

  function brl(cents) {
    return 'R$ ' + (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
  }

  function escopos() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cbv-frete]'));
  }

  function escopoDe(el) {
    return el && el.closest ? el.closest('[data-cbv-frete]') : null;
  }

  function achar(raiz, classe) {
    return raiz ? raiz.querySelector('.' + classe) : null;
  }

  /* Mesma regra da página de produto: encurta o prazo da transportadora conforme as
     faixas configuradas no tema. Duplicar a regra com outro critério faria a mesma
     entrega mostrar prazos diferentes em duas telas da loja. */
  function ajustarPrazo(dias, regras) {
    if (!dias || !Array.isArray(dias) || dias.length < 2 || !regras) return dias;
    var min = parseInt(dias[0], 10);
    var max = parseInt(dias[1], 10);
    if (isNaN(min) || isNaN(max)) return dias;
    var subtrai = 0;
    for (var k in regras) {
      var r = regras[k];
      if (!r || !r.enabled) continue;
      var rMin = parseInt(r.minDays, 10);
      var rMax = (r.maxDays && String(r.maxDays) !== '999') ? parseInt(r.maxDays, 10) : Infinity;
      if (max >= rMin && max <= rMax) { subtrai = parseInt(r.subtractDays, 10) || 0; break; }
    }
    if (!subtrai) return dias;
    return [Math.max(1, min - subtrai), Math.max(1, max - subtrai)];
  }

  /*
   * "em até 4 dias úteis" — o TETO, e só ele.
   *
   * Antes saía "chega entre 2 e 4 dias úteis", que é mais longo e diz menos: quem
   * compra quer saber quando pode contar com o tecido na mão, e essa é a data de cima.
   * A de baixo é promessa que a transportadora não deve.
   *
   * ⚠️ PRAZO ZERO APARECE, e está assim de propósito. Visto em 16/08/2026:
   * "CORREIOS - SEDEX | chega em 0 dias úteis". O `Math.max(1, …)` de `ajustarPrazo` só
   * protege quando alguma faixa CASA — quando a transportadora manda 0 e nenhuma regra
   * o alcança, o 0 atravessa inteiro.
   *
   * Chegou a haver aqui um `if (teto < 1) return ''` que escondia a linha do prazo. Foi
   * TIRADO a pedido do Gilberto em 16/08/2026: a origem é a Frete Rápido, que ia
   * corrigir no dia seguinte, e esconder o sintoma atrapalharia conferir se corrigiram.
   *
   * Se um dia o 0 voltar sem previsão de conserto na origem, o guard é uma linha — mas
   * aí é decisão de mostrar menos, não de consertar.
   */
  function textoPrazo(dias) {
    if (!dias || !Array.isArray(dias) || dias.length < 2) return '';
    var a = parseInt(dias[0], 10);
    var b = parseInt(dias[1], 10);
    if (isNaN(a) || isNaN(b)) return '';
    var teto = Math.max(a, b);
    return teto === 1 ? 'em até 1 dia útil' : 'em até ' + teto + ' dias úteis';
  }

  /*
   * Nome da transportadora, encurtado.
   *
   * A Shopify devolve o rótulo cheio da taxa — "TOTAL EXPRESS - Expresso",
   * "FM TRANSPORTES - Standard", "CORREIOS - SEDEX" —, e a linha inteira não cabia no
   * seletor: no celular o preço, que é o que decide, ficava cortado fora da tela.
   *
   * O serviço só informa alguma coisa nos CORREIOS, onde PAC e SEDEX são escolhas de
   * verdade — preço e prazo bem diferentes. Na Total e na FM o serviço é o único que
   * existe, então "Expresso" e "Standard" gastam espaço sem dizer nada: some.
   *
   *   TOTAL EXPRESS - Expresso   →  Total Express
   *   FM TRANSPORTES - Standard  →  FM Transportes
   *   CORREIOS - SEDEX           →  Correios/SEDEX
   *   CORREIOS - PAC             →  Correios/PAC
   *
   * Transportadora nova que apareça cai na regra geral (só o nome, em caixa de título)
   * — que é o comportamento certo por padrão. Se um dia ela tiver dois serviços que
   * importam, entra no `COM_SERVICO` como os Correios.
   */
  var COM_SERVICO = /correios/i;

  /* "TOTAL EXPRESS" → "Total Express", mas "FM TRANSPORTES" → "FM Transportes": palavra
     de até duas letras é sigla e continua em caixa alta, senão viraria "Fm". */
  function caixaDeTitulo(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/\S+/g, function (p) {
        if (p.length <= 2) return p.toUpperCase();
        return p.charAt(0).toUpperCase() + p.slice(1);
      });
  }

  function nomeCurto(nome) {
    var bruto = String(nome || '').trim();
    // Hífen comum, travessão ou barra vertical: as transportadoras variam.
    var partes = bruto.split(/\s+[-–|]\s+/);
    var transportadora = (partes[0] || bruto).trim();
    var servico = (partes[1] || '').trim();
    if (COM_SERVICO.test(transportadora)) {
      var base = caixaDeTitulo(transportadora);
      return servico ? base + '/' + servico.toUpperCase() : base;
    }
    return caixaDeTitulo(transportadora);
  }

  /*
   * O rótulo da ação conta O QUE O CLIQUE VAI FAZER, não o nome do cartão.
   * Fechado diz "Calcular"; aberto diz "Cancelar", porque aberto é isso que o clique
   * faz. Sem isso o botão fica dizendo "Calcular" com o campo de calcular já na tela,
   * e ninguém descobre como fechar.
   *
   * O texto de fechado vem do `data-rotulo` do próprio botão. Guardar numa variável
   * aqui não sobreviveria: o drawer é redesenhado a cada mudança de carrinho e o
   * botão volta do servidor novo em folha.
   */
  function rotularAcao(botao, aberto) {
    if (!botao) return;
    var fechado = botao.getAttribute('data-rotulo');
    botao.textContent = aberto ? 'Cancelar' : (fechado || botao.textContent);
  }

  /*
   * Escreve a linha de Subtotal do escopo — com o frete somado, quando há modalidade
   * escolhida.
   *
   * É o ÚNICO lugar que escreve esse texto, nos dois lados. Antes, no drawer, quem
   * escrevia era o `updateSubtotalFromCart`; com dois escritores a última chamada
   * vencia e o frete sumia ou reaparecia conforme a ordem em que resolvessem — o tipo
   * de bug que só dá as caras com a rede lenta.
   */
  function escreverSubtotal(raiz) {
    if (!raiz || baseCents == null) return;
    var seletor = raiz.getAttribute('data-frete-subtotal');
    if (!seletor) return;
    var el = document.querySelector(seletor);
    if (!el) return;
    var prefixo = raiz.getAttribute('data-frete-prefixo') || '';
    /*
     * REDE DE SEGURANCA: base 0 nao soma frete.
     *
     * Se quem le o carrinho deixar de avisar (foi o que aconteceu no caminho pos-add ate
     * 31/08/2026), baseCents fica no 0 do carregamento com carrinho vazio, e somar o frete
     * por cima faz a linha anunciar o VALOR DO FRETE como se fosse o subtotal — numero
     * menor que o do proprio item logo acima. Errar para menos aqui e errar em dinheiro na
     * cara do cliente. Sem base confiavel, mostra so a base: some o frete, nao o subtotal.
     * Carrinho de fato vazio tambem cai aqui, e nele nao ha frete a somar mesmo.
     */
    var soma = baseCents > 0 ? baseCents + (raiz.__freteCents || 0) : baseCents;
    el.textContent = prefixo + brl(soma);
  }

  /*
   * Lê a modalidade escolhida no <select> e reescreve o subtotal.
   *
   * A base é a mesma `items_subtotal_price` que a linha de Subtotal já mostra —
   * MERCADORIA, sem o desconto de PIX. Somar frete a um subtotal já com PIX daria um
   * total que só vale para quem paga em PIX, e a linha de cima estaria dizendo outra
   * coisa.
   */
  function lerModalidade(raiz) {
    var sel = achar(raiz, 'cbv-frete__opcoes');
    if (!sel) { raiz.__freteCents = null; escreverSubtotal(raiz); return; }
    var op = sel.options[sel.selectedIndex];
    var cents = op ? parseInt(op.getAttribute('data-preco'), 10) : NaN;
    raiz.__freteCents = isFinite(cents) ? cents : null;
    escreverSubtotal(raiz);
  }

  async function calcular(raiz) {
    var campo = achar(raiz, 'cbv-frete__cep');
    var botao = achar(raiz, 'cbv-frete__calcular');
    var saida = achar(raiz, 'cbv-frete__resultado');
    if (!campo || !botao || !saida) return;

    var aviso = function (t) { saida.innerHTML = '<p class="cbv-frete__aviso">' + t + '</p>'; };
    var cep = campo.value.replace(/\D/g, '');
    if (cep.length !== 8) { aviso('Digite um CEP com 8 dígitos.'); return; }

    botao.disabled = true;
    botao.classList.add('loading');
    aviso('Consultando…');

    try {
      var carrinho = await (await fetch('/cart.js')).json();
      if (!carrinho || !carrinho.item_count) {
        aviso('Adicione um tecido ao carrinho para calcular o frete.');
        return;
      }

      var via = await (await fetch('https://viacep.com.br/ws/' + cep + '/json/')).json();
      if (!via || via.erro || !via.uf) { aviso('CEP não encontrado. Confira e tente de novo.'); return; }

      var url = '/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + cep +
                '&shipping_address%5Bcountry%5D=BR&shipping_address%5Bprovince%5D=' + via.uf;
      var resp = await fetch(url);
      if (!resp.ok) { aviso('Não consegui calcular agora. Tente em instantes.'); return; }
      var dados = await resp.json();
      var taxas = (dados && dados.shipping_rates) || [];
      if (!taxas.length) { aviso('Não encontramos entrega para este CEP.'); return; }

      var regras = {};
      try { regras = JSON.parse(raiz.getAttribute('data-delivery-rules') || '{}'); } catch (e) {}

      /* Do mais barato para o mais caro. As transportadoras respondem em ordem
         arbitrária, e medindo em 14/08/2026 os Correios saíam a R$ 96 no mesmo trecho
         que a FM fazia por R$ 17 — deixar o caro em cima assusta à toa. */
      taxas.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });

      /* Seletor em vez de lista: quatro transportadoras empilhadas empurravam o botão
         de finalizar para fora da tela. Fechado ocupa uma linha e já mostra a mais
         barata, que é a que a maioria escolhe. */
      var html = '<p class="cbv-frete__legenda">Selecione a sua modalidade</p>' +
                 '<select class="cbv-frete__seletor cbv-frete__opcoes">';
      taxas.forEach(function (t, i) {
        var v = parseFloat(t.price);
        var preco = v === 0 ? 'Grátis' : 'R$ ' + v.toFixed(2).replace('.', ',');
        var prazo = textoPrazo(ajustarPrazo(t.delivery_days, regras));
        /* O preço vai no `data-preco`, em CENTAVOS. A Shopify devolve `price` como
           string em reais ("17.00"); somar isso ao subtotal, que é em centavos, daria
           um total absurdo — e o erro passaria despercebido porque o número continua
           parecendo dinheiro. */
        html += '<option value="' + i + '" data-preco="' + Math.round(v * 100) + '">' +
                nomeCurto(t.name) + (prazo ? ' | ' + prazo : '') + ' — ' + preco + '</option>';
      });
      html += '</select>' +
              '<p class="cbv-frete__nota">Estimativa. O prazo começa a contar após o envio do pedido.</p>';
      saida.innerHTML = html;

      /* A primeira opção já vem selecionada (é a mais barata, depois da ordenação),
         então o resumo tem de aparecer AGORA — esperar o `change` deixaria a cliente
         vendo uma modalidade escolhida e nenhum total. */
      lerModalidade(raiz);

      /* Calculado: onde o cartão tem cabeçalho com etiqueta (o drawer), ele passa a
         mostrar o CEP e o campo se recolhe. No /cart não há etiqueta e o campo fica
         onde estava, com o CEP à vista — que é a mesma informação, sem o recolhimento
         que aquele espaço apertado exigia. */
      mostrarEtiqueta(raiz, campo.value);

      try { localStorage.setItem(CHAVE_CEP, campo.value); } catch (e) {}
    } catch (e) {
      aviso('Não consegui calcular agora. Tente em instantes.');
    } finally {
      botao.disabled = false;
      botao.classList.remove('loading');
    }
  }

  /* Troca "Calcular" pela etiqueta do CEP no cabeçalho, e recolhe o campo.
     Sem cabeçalho recolhível (o caso do /cart) não há nada a fazer, e sair aqui é o
     comportamento certo — não uma falha silenciosa. */
  function mostrarEtiqueta(raiz, cep) {
    var abrir = achar(raiz, 'cbv-frete__abrir');
    var etiqueta = achar(raiz, 'cbv-frete__etiqueta');
    var texto = achar(raiz, 'cbv-frete__etiqueta-texto');
    var corpo = achar(raiz, 'cbv-frete__corpo');
    if (!abrir || !etiqueta || !texto) return;
    texto.textContent = cep;
    abrir.hidden = true;
    etiqueta.hidden = false;
    if (corpo) corpo.hidden = true;
    // Escondido agora, mas volta pela etiqueta: tem que voltar dizendo "Calcular".
    rotularAcao(abrir, false);
  }

  /* Volta ao estado inicial: some a etiqueta, volta o "Calcular", limpa o resultado. */
  function limpar(raiz) {
    var abrir = achar(raiz, 'cbv-frete__abrir');
    var etiqueta = achar(raiz, 'cbv-frete__etiqueta');
    var corpo = achar(raiz, 'cbv-frete__corpo');
    var saida = achar(raiz, 'cbv-frete__resultado');
    var campo = achar(raiz, 'cbv-frete__cep');
    if (abrir) abrir.hidden = false;
    if (etiqueta) etiqueta.hidden = true;
    if (saida) saida.innerHTML = '';
    if (corpo) corpo.hidden = false;
    // Volta com o campo ABERTO para digitar o CEP novo, então a ação é "Cancelar".
    if (abrir) rotularAcao(abrir, true);
    if (campo) { campo.value = ''; campo.focus(); }
    try { localStorage.removeItem(CHAVE_CEP); } catch (e) {}
    /*
     * E O SUBTOTAL VOLTA A SER SÓ MERCADORIA.
     *
     * O `saida.innerHTML = ''` logo acima destrói o <select> de modalidade, mas o
     * valor escolhido continuava guardado no escopo — então o subtotal seguia com um
     * frete somado que já não existia em lugar nenhum da tela, e não havia como
     * tirá-lo a não ser recarregando.
     *
     * Quem apaga o seletor tem de zerar o valor junto: os dois são a mesma escolha.
     */
    raiz.__freteCents = null;
    escreverSubtotal(raiz);
  }

  /*
   * Devolve o CEP a cada redesenho.
   *
   * ⚠️ OS DOIS LADOS SÃO REDESENHADOS A CADA MUDANÇA DE CARRINHO — o drawer inteiro,
   * e no /cart o `innerHTML` de `#cart`. O HTML volta do servidor no estado inicial:
   * campo vazio, resultado vazio. Sem isto, quem já calculou o frete e depois mexe na
   * metragem vê o cartão "esquecer" o CEP. Como o CEP fica no navegador, dá para
   * reconstituir.
   *
   * SÓ O CEP VOLTA. A cotação NÃO, de propósito: o carrinho mudou e frete depende de
   * peso. Uma etiqueta de "já calculei" sem cotação deixaria a tela mentindo, e ainda
   * esconderia o caminho de refazer o cálculo.
   *
   * A alternativa era recalcular sozinho. Descartada com o Gilberto em 15/08/2026:
   * cobraria uma consulta de frete a cada redesenho, e o ganho não paga.
   */
  function preencherCepSalvo() {
    var salvo = null;
    try { salvo = localStorage.getItem(CHAVE_CEP); } catch (e) { return; }
    if (!salvo) return;
    escopos().forEach(function (raiz) {
      var campo = achar(raiz, 'cbv-frete__cep');
      if (campo && !campo.value) campo.value = salvo;
    });
  }

  /*
   * ⚠️ DELEGAÇÃO NO DOCUMENTO, e não `botao.addEventListener`.
   *
   * Os dois lados são REDESENHADOS a cada busca de carrinho: o botão que recebeu o
   * ouvinte é jogado fora e nasce outro no lugar, sem ouvinte nenhum. Ligar direto no
   * elemento dava um sintoma que enganava — o primeiro clique depois de abrir o
   * carrinho não fazia nada e o segundo funcionava, conforme o redesenho tivesse
   * acontecido ou não no meio. Pego no teste de 14/08/2026, antes de publicar.
   *
   * O documento não é redesenhado: um ouvinte só, e resolve para sempre.
   */
  document.addEventListener('input', function (ev) {
    var campo = ev.target && ev.target.closest && ev.target.closest('.cbv-frete__cep');
    if (!campo) return;
    var d = campo.value.replace(/\D/g, '').slice(0, 8);
    campo.value = d.length > 5 ? d.replace(/^(\d{5})(\d+)$/, '$1-$2') : d;
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter') return;
    var campo = ev.target && ev.target.closest && ev.target.closest('.cbv-frete__cep');
    if (!campo) return;
    ev.preventDefault();
    var raiz = escopoDe(campo);
    if (raiz) calcular(raiz);
  });

  document.addEventListener('click', function (ev) {
    if (!ev.target || !ev.target.closest) return;

    var btn = ev.target.closest('.cbv-frete__calcular');
    if (btn) { var r1 = escopoDe(btn); if (r1) calcular(r1); return; }

    /* "Calcular" no cabeçalho: abre o campo e já deixa o cursor nele. */
    var abrir = ev.target.closest('.cbv-frete__abrir');
    if (abrir) {
      var r2 = escopoDe(abrir);
      if (!r2) return;
      var corpo = achar(r2, 'cbv-frete__corpo');
      var campo = achar(r2, 'cbv-frete__cep');
      if (corpo) corpo.hidden = !corpo.hidden;
      rotularAcao(abrir, corpo && !corpo.hidden);
      if (campo && corpo && !corpo.hidden) campo.focus();
      return;
    }

    /* "×" da etiqueta: esquece o CEP e volta ao começo. */
    var x = ev.target.closest('.cbv-frete__limpar');
    if (x) { var r3 = escopoDe(x); if (r3) limpar(r3); return; }
  });

  /* Trocou a modalidade: refaz o total. Delegado pelo mesmo motivo dos outros — o
     <select> nasce e morre a cada cálculo. */
  document.addEventListener('change', function (ev) {
    var sel = ev.target && ev.target.closest && ev.target.closest('.cbv-frete__opcoes');
    if (!sel) return;
    var raiz = escopoDe(sel);
    if (raiz) lerModalidade(raiz);
  });

  document.addEventListener('DOMContentLoaded', preencherCepSalvo);
  document.addEventListener('cart:updated', preencherCepSalvo);
  document.addEventListener('cart:refresh', preencherCepSalvo);
  preencherCepSalvo();

  window.cbvFrete = {
    /*
     * Chamado por quem acabou de ler o carrinho, nos dois lados.
     *
     * Zerar as cotações aqui é DELIBERADO: mudou a metragem, a cotação daquela consulta
     * não vale mais — o frete depende do peso. Deixar o total antigo na tela seria pior
     * que não mostrar nada, porque ele continua parecendo atual.
     */
    definirBase: function (cents) {
      baseCents = Number(cents) || 0;
      escopos().forEach(function (raiz) {
        raiz.__freteCents = null;
        escreverSubtotal(raiz);
      });
    },
    preencherCepSalvo: preencherCepSalvo
  };
})();
